import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";

const BulkUpdateColorVariant = () => {

    const dispatch = useDispatch();

    const fileUploadMsg = useSelector((state) => state.commonReducer.fileUploadMsg);

    const [data, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(20);
    const [totalCount, setTotalCount] = useState('');

    const paginate = (pageNumber) => setCurrentPage(pageNumber);




    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;

    const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));


    useEffect(async () => {

        console.log(currentPage);

        const indexOfLastItem = currentPage * itemPerPage;
        const indexOfFirstItem = indexOfLastItem - itemPerPage;

        var payload = {
            offsetItem: indexOfFirstItem,
            itemPerPage
        }

        refetchPOList.mutate(payload)
    }, [itemPerPage, currentPage]);


    const getPurchseOrders = async (param) => {
        try {            
            const { data } = await loginAxios.get(`designers/product/logs_color_variants_mapping?status=pending?offset=${param.offsetItem}&limit=${param.itemPerPage}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const refetchPOList = useMutation(getPurchseOrders, {
        // refetchOnMount: false,
        // refetchOnWindowFocus: false,
        onSettled(data, error) {
            if (data) {
                console.log(data.data);
                setData(data?.data);
                setTotalCount(data.data?.totalCount)
            }
        }
    })



    // useEffect(() => {
    //     // refetchPOList.mutate(payload)
    //     refetchPOList.mutate()
    // }, [])


    useEffect(() => {
        console.log(fileUploadMsg);

        if (fileUploadMsg?.status == true) {

            toast.success(fileUploadMsg?.msg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });

            dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: {} });

        } else if (fileUploadMsg?.status == false) {
            toast.error(fileUploadMsg?.msg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });

            dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: {} });
        }



    }, [fileUploadMsg]);

    return (<>

        {/* /bulk-update-add */}
        <Head title="Bulk Update"></Head>
        <div style={{marginTop: '64px'}}>
                <Alert className="alert-icon" color="secondary">
                    <Icon name="alert-circle" />
                    <strong>Note - </strong>. Please check after some time if you have uploaded a large set of data                    
                </Alert>
            </div>
        <Content>            
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Bulk Update Color Variant</BlockTitle>


                        {userLoginDetails.profile_approval_status != "PENDING" &&

                            <div className="toggle-wrap nk-block-tools-toggle">
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">

                                        <li className="nk-block-tools-opt">
                                            <Link to='bulk-update-color-variant-add'>
                                                <Button color="primary" className="btn-icon btn-sm" id="addBtn">
                                                    <Icon name="plus"></Icon>
                                                </Button>
                                            </Link>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        }

                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Card className="card-stretch">
                    <div className="card-inner-group">


                        <DataTable className="card-stretch">
                            <DataTableBody compact>
                                <DataTableHead>
                                    {/* <DataTableRow size="sm">
                                        <span>ID</span>
                                    </DataTableRow> */}

                                    <DataTableRow size="sm">
                                        <span>ID</span>
                                    </DataTableRow>

                                    <DataTableRow size="sm">
                                        <span>UPLOADED FILE</span>
                                    </DataTableRow>
                                    <DataTableRow size="sm">
                                        <span>SUCCESS COUNT</span>
                                    </DataTableRow>
                                    <DataTableRow size="sm">
                                        <span>ERROR COUNT</span>
                                    </DataTableRow>
                                    <DataTableRow size="sm">
                                        <span>FAILED FILE</span>
                                    </DataTableRow>

                                    {/* <DataTableRow size="sm">
                                        <span>ADDED BY</span>
                                    </DataTableRow> */}

                                    <DataTableRow size="sm">
                                        <span>DATE ADDED</span>
                                    </DataTableRow>

                                </DataTableHead>


                                    {console.log('ata ata ata', data)}


                                {data?.list?.rows?.length > 0
                                    ? data?.list?.rows?.map((item) => {
                                        return (
                                            <DataTableItem key={item.id}>

                                                <DataTableRow size="sm">
                                                    <span>{item.id}</span>
                                                </DataTableRow>

                                                <DataTableRow size="sm">
                                                    {item.uploaded_file_url ? <a href={item.uploaded_file_url} download target="_blank" style={{ color: '#0000EE', display: 'inline-block', whiteSpace: 'nowrap', width: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {`${item.uploaded_file_url ? item.uploaded_file_url : "Not Available "}`}
                                                    </a> : <span>Not Available</span>}

                                                </DataTableRow>
                                                <DataTableRow size="sm">
                                                    <span>{item.count_success}</span>
                                                </DataTableRow>
                                                <DataTableRow size="sm">
                                                    <span>{item.count_error}</span>
                                                </DataTableRow>
                                                <DataTableRow size="sm">
                                                    {item.exception_file_url ?
                                                        <a href={item.exception_file_url} download target="_blank" style={{ color: '#0000EE', display: 'inline-block', whiteSpace: 'nowrap', width: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            {`${item.exception_file_url ? item.exception_file_url : "Not Available "}`}
                                                        </a>
                                                        : <span>Not Available</span>
                                                    }
                                                </DataTableRow>

                                                {/* <DataTableRow size="sm">
                                                    <span>{item.added_by}</span>
                                                </DataTableRow> */}

                                                <DataTableRow size="sm">

                                                    <span className="date-inline">{moment(item.date_added).format("YYYY-MM-DD HH:mm")}</span>
                                                </DataTableRow>

                                            </DataTableItem>
                                        );
                                    })
                                    : null}

                            </DataTableBody>

                            <div className="card-inner">
                                {data?.list?.rows?.length > 0 ? (
                                    // <PaginationComponent
                                    //     itemPerPage={itemPerPage}
                                    //     totalItems={totalCount}
                                    //     paginate={paginate}
                                    //     currentPage={currentPage}
                                    // />
                                    
                                    <PaginationComponent
                                        itemPerPage={itemPerPage}                      
                                        totalItems={data?.list?.count || []}
                                        paginate={paginate}
                                        currentPage={currentPage}                      
                                        setItemPerPage={setItemPerPage}
                                        setCurrentPage={setCurrentPage}                                            
                                    />
                                ) : (
                                    <div className="text-center">
                                        <span className="text-silent">No data found</span>
                                    </div>
                                )}
                            </div>
                        </DataTable>

                    </div>
                </Card>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default BulkUpdateColorVariant;